var _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14125_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C23.9556 4.71704e-08 27.8224 1.17298 31.1114 3.37061C34.4004 5.56824 36.9638 8.69181 38.4776 12.3463C39.9913 16.0009 40.3874 20.0222 39.6157 23.9018C38.844 27.7814 36.9392 31.3451 34.1421 34.1421L27.0711 27.0711C28.4696 25.6725 29.422 23.8907 29.8079 21.9509C30.1937 20.0111 29.9957 18.0004 29.2388 16.1732C28.4819 14.3459 27.2002 12.7841 25.5557 11.6853C23.9112 10.5865 21.9778 10 20 10V0Z",
    fill: "#FF0400"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_14125_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1421 34.1421C31.9729 36.3114 29.3337 37.9525 26.4288 38.9386C23.5238 39.9247 20.431 40.2293 17.3895 39.8289C14.348 39.4285 11.4393 38.3337 8.8886 36.6294C6.33785 34.925 4.21337 32.6568 2.67949 30L11.3397 25C12.1067 26.3284 13.1689 27.4625 14.4443 28.3147C15.7197 29.1669 17.174 29.7142 18.6947 29.9144C20.2155 30.1147 21.7619 29.9623 23.2144 29.4693C24.6669 28.9763 25.9865 28.1557 27.0711 27.0711L34.1421 34.1421Z",
    fill: "#FFA300"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_14125_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.67949 30C0.47815 26.1872 -0.403563 21.7545 0.171103 17.3895C0.745768 13.0245 2.7447 8.97103 5.85786 5.85787L12.9289 12.9289C11.3723 14.4855 10.3729 16.5122 10.0856 18.6947C9.79822 20.8772 10.2391 23.0936 11.3397 25L2.67949 30Z",
    fill: "#FF6300"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_14125_22559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.85786 5.85787C7.71503 4.00069 9.91982 2.5275 12.3463 1.52241C14.7728 0.517315 17.3736 -3.132e-08 20 0V10C18.6868 10 17.3864 10.2587 16.1732 10.7612C14.9599 11.2638 13.8575 12.0003 12.9289 12.9289L5.85786 5.85787Z",
    fill: "#FF4200"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_14125_22559)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_14125_22559",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 16C18.6863 16 16 18.6863 16 22V54C16 57.3137 18.6863 60 22 60H46C49.3137 60 52 57.3137 52 54V22C52 18.6863 49.3137 16 46 16H22ZM24 22C22.8954 22 22 22.8954 22 24V30C22 31.1046 22.8954 32 24 32H44C45.1046 32 46 31.1046 46 30V24C46 22.8954 45.1046 22 44 22H24Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 16C18.6863 16 16 18.6863 16 22V54C16 57.3137 18.6863 60 22 60H46C49.3137 60 52 57.3137 52 54V22C52 18.6863 49.3137 16 46 16H22ZM24 22C22.8954 22 22 22.8954 22 24V30C22 31.1046 22.8954 32 24 32H44C45.1046 32 46 31.1046 46 30V24C46 22.8954 45.1046 22 44 22H24Z",
    fill: "url(#paint0_linear_14125_22559)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 16C18.6863 16 16 18.6863 16 22V54C16 57.3137 18.6863 60 22 60H46C49.3137 60 52 57.3137 52 54V22C52 18.6863 49.3137 16 46 16H22ZM24 22C22.8954 22 22 22.8954 22 24V30C22 31.1046 22.8954 32 24 32H44C45.1046 32 46 31.1046 46 30V24C46 22.8954 45.1046 22 44 22H24Z",
    fill: "url(#paint1_radial_14125_22559)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 22C17 19.2386 19.2386 17 22 17V15C18.134 15 15 18.134 15 22H17ZM17 54V22H15V54H17ZM22 59C19.2386 59 17 56.7614 17 54H15C15 57.866 18.134 61 22 61V59ZM46 59H22V61H46V59ZM51 54C51 56.7614 48.7614 59 46 59V61C49.866 61 53 57.866 53 54H51ZM51 22V54H53V22H51ZM46 17C48.7614 17 51 19.2386 51 22H53C53 18.134 49.866 15 46 15V17ZM22 17H46V15H22V17ZM23 24C23 23.4477 23.4477 23 24 23V21C22.3431 21 21 22.3431 21 24H23ZM23 30V24H21V30H23ZM24 31C23.4477 31 23 30.5523 23 30H21C21 31.6569 22.3431 33 24 33V31ZM44 31H24V33H44V31ZM45 30C45 30.5523 44.5523 31 44 31V33C45.6569 33 47 31.6569 47 30H45ZM45 24V30H47V24H45ZM44 23C44.5523 23 45 23.4477 45 24H47C47 22.3431 45.6569 21 44 21V23ZM24 23H44V21H24V23Z",
    fill: "url(#paint2_radial_14125_22559)",
    mask: "url(#path-5-inside-1_14125_22559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 22C17 19.2386 19.2386 17 22 17V15C18.134 15 15 18.134 15 22H17ZM17 54V22H15V54H17ZM22 59C19.2386 59 17 56.7614 17 54H15C15 57.866 18.134 61 22 61V59ZM46 59H22V61H46V59ZM51 54C51 56.7614 48.7614 59 46 59V61C49.866 61 53 57.866 53 54H51ZM51 22V54H53V22H51ZM46 17C48.7614 17 51 19.2386 51 22H53C53 18.134 49.866 15 46 15V17ZM22 17H46V15H22V17ZM23 24C23 23.4477 23.4477 23 24 23V21C22.3431 21 21 22.3431 21 24H23ZM23 30V24H21V30H23ZM24 31C23.4477 31 23 30.5523 23 30H21C21 31.6569 22.3431 33 24 33V31ZM44 31H24V33H44V31ZM45 30C45 30.5523 44.5523 31 44 31V33C45.6569 33 47 31.6569 47 30H45ZM45 24V30H47V24H45ZM44 23C44.5523 23 45 23.4477 45 24H47C47 22.3431 45.6569 21 44 21V23ZM24 23H44V21H24V23Z",
    fill: "url(#paint3_radial_14125_22559)",
    fillOpacity: 0.5,
    mask: "url(#path-5-inside-1_14125_22559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 22C17 19.2386 19.2386 17 22 17V15C18.134 15 15 18.134 15 22H17ZM17 54V22H15V54H17ZM22 59C19.2386 59 17 56.7614 17 54H15C15 57.866 18.134 61 22 61V59ZM46 59H22V61H46V59ZM51 54C51 56.7614 48.7614 59 46 59V61C49.866 61 53 57.866 53 54H51ZM51 22V54H53V22H51ZM46 17C48.7614 17 51 19.2386 51 22H53C53 18.134 49.866 15 46 15V17ZM22 17H46V15H22V17ZM23 24C23 23.4477 23.4477 23 24 23V21C22.3431 21 21 22.3431 21 24H23ZM23 30V24H21V30H23ZM24 31C23.4477 31 23 30.5523 23 30H21C21 31.6569 22.3431 33 24 33V31ZM44 31H24V33H44V31ZM45 30C45 30.5523 44.5523 31 44 31V33C45.6569 33 47 31.6569 47 30H45ZM45 24V30H47V24H45ZM44 23C44.5523 23 45 23.4477 45 24H47C47 22.3431 45.6569 21 44 21V23ZM24 23H44V21H24V23Z",
    fill: "url(#paint4_radial_14125_22559)",
    mask: "url(#path-5-inside-1_14125_22559)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_bi_14125_22559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21,
    width: 26,
    height: 12,
    rx: 2,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21,
    width: 26,
    height: 12,
    rx: 2,
    fill: "white",
    fillOpacity: 0.9
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0607 41.9393C46.4749 41.3536 45.5251 41.3536 44.9393 41.9393L42.5 44.3787L40.0607 41.9393C39.4749 41.3536 38.5251 41.3536 37.9393 41.9393C37.3536 42.5251 37.3536 43.4749 37.9393 44.0607L40.3787 46.5L37.9393 48.9393C37.3536 49.5251 37.3536 50.4749 37.9393 51.0607C38.5251 51.6464 39.4749 51.6464 40.0607 51.0607L42.5 48.6213L44.9393 51.0607C45.5251 51.6464 46.4749 51.6464 47.0607 51.0607C47.6464 50.4749 47.6464 49.5251 47.0607 48.9393L44.6213 46.5L47.0607 44.0607C47.6464 43.4749 47.6464 42.5251 47.0607 41.9393Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5 46.5C34.5 45.6716 33.8284 45 33 45H24C23.1716 45 22.5 45.6716 22.5 46.5C22.5 47.3284 23.1716 48 24 48H33C33.8284 48 34.5 47.3284 34.5 46.5Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3008 50.5C30.3008 51.4945 29.4945 52.3008 28.5 52.3008C27.5055 52.3008 26.6992 51.4945 26.6992 50.5C26.6992 49.5055 27.5055 48.6992 28.5 48.6992C29.4945 48.6992 30.3008 49.5055 30.3008 50.5Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3008 42.5C30.3008 43.4945 29.4945 44.3008 28.5 44.3008C27.5055 44.3008 26.6992 43.4945 26.6992 42.5C26.6992 41.5055 27.5055 40.6992 28.5 40.6992C29.4945 40.6992 30.3008 41.5055 30.3008 42.5Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 42L41.5 45.5M38 49L41.5 45.5M41.5 45.5L38 42M41.5 45.5L45 49",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45.5H28H23",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 49.5,
    r: 1.80078,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3008 41.5C29.3008 42.4945 28.4945 43.3008 27.5 43.3008C26.5055 43.3008 25.6992 42.4945 25.6992 41.5C25.6992 40.5055 26.5055 39.6992 27.5 39.6992C28.4945 39.6992 29.3008 40.5055 29.3008 41.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14125_22559",
    x: 16,
    y: -4,
    width: 28,
    height: 42.1421,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14125_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14125_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_14125_22559",
    x: -1.32056,
    y: 21,
    width: 39.4626,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14125_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14125_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_14125_22559",
    x: -4,
    y: 1.85791,
    width: 20.929,
    height: 32.1421,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14125_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14125_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_14125_22559",
    x: 1.85791,
    y: -4,
    width: 22.1421,
    height: 20.9287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14125_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14125_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_14125_22559",
    x: 8,
    y: 8,
    width: 52,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14125_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14125_22559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bi_14125_22559",
    x: 17,
    y: 17,
    width: 34,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14125_22559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14125_22559",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.533333 0 0 0 0 0.635294 0 0 0 0 0.694118 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_14125_22559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14125_22559",
    x1: 16,
    y1: 16,
    x2: 40.4719,
    y2: 56.0449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14125_22559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 16) scale(36 44)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14125_22559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5 44.7222) rotate(7.46056) scale(14.1195 17.161)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_14125_22559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5 23.9444) rotate(129.289) scale(7.10634 30.7912)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_14125_22559",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5 24.5556) rotate(112.249) scale(19.8081 17.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.3dbdcd84c04e98c67135a87d55513e8a.svg";
export { ForwardRef as ReactComponent };